import { render, staticRenderFns } from "./UCPALogo.vue?vue&type=template&id=16d620d8"
import script from "./UCPALogo.vue?vue&type=script&lang=js"
export * from "./UCPALogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports